let sessionTimeout: number;

export const setSessionTimeout = (value: number) => (sessionTimeout = value);

/**
 * Gets the session timeout in minutes
 */
export const getSessionTimeout = () => sessionTimeout;
